import * as React from 'react';
import { FieldError } from 'react-hook-form';

interface Props {
  label: string;
  children: React.ReactNode;
  error?: FieldError;
  className?: string;
}

/**
 * Abstraction for our sign in form inputs so we only
 * have to style them once
 */
export const InputWrapper: React.FC<Props> = (props) => {
  return (
    <div className={`space-y-1 ${props.className || ''}`}>
      <h4 className="text-gray-900 font-medium">{props.label}</h4>
      {props.children}
      {props.error && <span className="text-red-900">{props.error.message}</span>}
    </div>
  );
};
InputWrapper.displayName = 'SignInput.Wrapper';
